import axios from 'axios'

const URL = "https://overpass-api.de/api/interpreter"

export default async (overpass_ql_code)  => {

    const full_url = URL + '?data=' + encodeURI(overpass_ql_code)

    let response = null

    try {
        response = await axios.get(full_url, {
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    })


    } catch (error) {
        throw error
    }

    return response.data.elements
}